document.addEventListener("DOMContentLoaded", function (event) {
  let vh = window.innerHeight * 0.01;
  var banner = document.querySelector(".banner");
  banner.style.setProperty("--vh", `${vh}px`);

  // 初回アクセス時のみ実行
  var fistLanding = sessionStorage.getItem("firstLanding");
  console.log("fistLanding", fistLanding);
  var body = document.querySelector("body");
  body.classList.remove("visibility-hidden");
  var homeBanner = document.querySelector("#MainContent > div > section:first-child > div");

  if (!fistLanding) {
    var homeAnimationBanner = document.querySelector(".home-banner");
    homeAnimationBanner.style.display = "flex";
    var mobileMedia = homeBanner.querySelector(".mobile-image__banner");
    var desktopMedia = homeBanner.querySelector(".desktop-image__banner");
    mobileMedia.classList.add("animation-banner-img");
    desktopMedia.classList.add("animation-banner-img");

    setTimeout(function () {
      var homeAnimationBanner = document.querySelector(".home-banner");
      homeAnimationBanner.style.display = "none";
    }, 4500);

    sessionStorage.setItem("firstLanding", true);
  }
});
